import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../theme/colors';

export interface CustomColor {
  font: string;
  border: string;
  icon?: string;
}

export const useTextInputStyles = makeStyles({
  defaultCustomInput: (custom: CustomColor) => ({
    color: custom.font,
    borderBottomColor: custom.border ? custom.border : colors.silver,
    '&:before': {
      borderColor: custom.border ? custom.border : colors.silver,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: custom.border ? custom.border : colors.silver,
      borderWidth: 1,
    },
  }),
  correctCustomInput: (custom: CustomColor) => ({
    color: custom.font,
    borderBottomColor: custom.border ? custom.border : colors.shamrock,
    '&:before': {
      borderColor: custom.border ? custom.border : colors.shamrock,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: custom.border ? custom.border : colors.shamrock,
    },
    '& .MuiInputAdornment-root': {
      color: custom.font,
    },
  }),
  errorCustomInput: (custom: CustomColor) => ({
    color: custom.font,
    borderBottomColor: custom.border ? custom.border : colors.bright_pink,
    '&:before': {
      borderColor: custom.border ? custom.border : colors.bright_pink,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: custom.border ? custom.border : colors.bright_pink,
    },
  }),
});
